module.exports = __webpack_public_path__ + "img/lg_ring_r_s_0_1@3x.aacec3db.png";